import axios from 'axios';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import BatterTable from '../../../components/table/BatterTable';
import { flatObject } from '../../../utils/flat';
import {useCookies} from 'react-cookie';
import TableWrapper from '../../../components/table/TableWrapper';
import dateSetting from '../../../utils/dateSetting';
import { useLocation } from 'react-router-dom';

function TotalFuturesBatterRecord({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [loading, setLoading] = useState(false);
    let [seasonRecord, setSeasonRecord] = useState({});
    let {playerId, birthdate} = profile;
    
    useEffect(() => {
        let dateObj = dateSetting();
        
        let basicRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresBatterRecord',
                batterIds: playerId,
                seasons: [dateObj['season']-2, dateObj['season']-1, dateObj['season']].toString(),
                gameTypeCode: 4206,
                groupingColumn: 'season',
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let trackmanRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresBatterTrackManRecord',
                batterIds: playerId,
                seasons: [dateObj['season']-2, dateObj['season']-1, dateObj['season']].toString(),
                gameTypeCode: 4206,
                groupingColumn: 'season',
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        })

        Promise.all([
            basicRecord,
            trackmanRecord
        ]).then((result) => {
            let trackman = _.map(result[1]['data']['result'], (item) => {
                item['hardHitRate'] = item['hardHit'] ? ((item['hardHit'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['barrelRate'] = item['barrel'] ? ((item['barrel'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['solidContactRate'] = item['solidContact'] ? ((item['solidContact'] / item['inplay'])*100).toFixed(1) : '0.0';

                item['lineDriveRate'] = item['lineDrive'] ? ((item['lineDrive'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['popUpRate'] = item['popUp'] ? ((item['popUp'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['flyRate'] = item['flyBall'] ? ((item['flyBall'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['groundBallRate'] = item['groundBall'] ? ((item['groundBall'] / item['inplay'])*100).toFixed(1) : '0.0';

                item['hangRate'] = item['hang'] ? ((item['hang'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['centerRate'] = item['center'] ? ((item['center'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['pushRate'] = item['push'] ? ((item['push'] / item['inplay'])*100).toFixed(1) : '0.0';

                item['poorlyToppedRate'] = item['poorlyTopped'] ? ((item['poorlyTopped'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['poorlyUnderRate'] = item['poorlyUnder'] ? ((item['poorlyUnder'] / item['inplay'])*100).toFixed(1) : '0.0';

                item['kRate'] = item['soRate'];

                item['xba'] = (item['xba']*1).toFixed(3);
                return item;
            });

            let trackmanFlatRecord = _.map(result[1]['data']['result'], (item) => {
                item['type'] = item['season']+"_"+item['batterId'];
                return item;
            });

            let indexedTrackmanData = _.keyBy(trackmanFlatRecord, (item) => item['season']);

            let basicRecord = result[0]['data']['result'];
            let basicFlatRecord = _.map(basicRecord, (item) => {
                let season = item['season'];
                let birthdateYear = birthdate && birthdate.split('/');
                let age = (season*1-birthdateYear[0]*1)-1;

                let trackmanSeasonData = indexedTrackmanData[season];
                item['solidContactRate'] = trackmanSeasonData ? trackmanSeasonData['solidContactRate'] : '';
                item['hardHitRate'] = trackmanSeasonData ? trackmanSeasonData['hardHitRate'] : '';
                item['barrelRate'] = trackmanSeasonData ? trackmanSeasonData['barrelRate'] : '';
                item['kRate'] = trackmanSeasonData ? trackmanSeasonData['soRate'] : '';
                item['bbRate'] = trackmanSeasonData ? trackmanSeasonData['bbRate'] : '';
                
                item['type'] = item['kboGameId'];
                item['age'] = age;
                return item;
            });

            // console.log(basicFlatRecord);
            // console.log(trackman);

            setSeasonRecord({
                seasonRecord: basicFlatRecord,
                trackmanRecord: trackman
            });
            setLoading(true);
        })
    }, []);

    if(!loading) {
        return <div style={{height: '300px'}}><DefaultLoader /></div>
    }

    return (
        <>
        <TableWrapper title={'overall'} id={'batter_total'} trackmanYn={true}>
            <BatterTable data={seasonRecord['seasonRecord']} column={'futuresTotal'}/>
        </TableWrapper>
        <TableWrapper title={'plateDisciplines'} id={'batter_contact'}>
            <BatterTable data={seasonRecord['trackmanRecord']} column={'futuresContact'}/>
        </TableWrapper>
        <TableWrapper title={'battedBallQuality'} id={'batter_power'}>
            <BatterTable data={seasonRecord['trackmanRecord']} column={'futuresPower'}/>
        </TableWrapper>
        <TableWrapper title={'battedBallType'} id={'batter_hittingType'}>
            <BatterTable data={seasonRecord['trackmanRecord']} column={'futuresHittingType'}/>
        </TableWrapper>
        </>
    )
}

export default TotalFuturesBatterRecord;